import { useTranslation } from "react-i18next";

export function AppFooter({ onOpenTerms }: { onOpenTerms: () => void }) {
  const { t, i18n } = useTranslation();
  return (
    <footer className="app-footer">
      <span>{t("footer.rights")}</span>
      <a
        href={
          i18n.language === "it"
            ? "https://accelasearch.com/privacy-policy/"
            : "https://accelasearch.com/en/privacy-policy/"
        }
        target="_blank"
        rel="noreferrer"
      >
        {t("footer.privacy")}
      </a>
      <button onClick={onOpenTerms}>{t("footer.terms")}</button>
    </footer>
  );
}
